// Приветственное окно после регистрации
// (собирает компанию, должность и другую информацию для маркетинга).

import urls from "../urls";
import createComponent from "../vue";
import cookies from "../cookies";
import ApiRequest from "../api-request";

const BASE_URL = urls.api.demo.getUrl();
const CSRF_TOKEN = cookies.get("csrftoken");
const TOKEN = window.DA.settings.API_KEY;
const $ = window.jQuery;

const state = function () {
    return {
        user_id: "",
        csrf_token: "",
        company_name: "",
        company_inn: "",
        company_kpp: "",
        company_address: "",
        company: null,
        industry: "",
        role: "",
        errors: {},
        finished: false,
        show: false,
    };
};

const methods = {
    init() {
        const el = $(this.$refs.company_name);
        const params = {
            serviceUrl: urls.api.demo.getUrl(),
            token: window.DA.settings.API_KEY,
            type: "PARTY",
            onSelect: this.onSelect,
            onSelectNothing: this.onSelectNothing,
        };
        el.suggestions(params);
        this.setFocus();
    },

    onSelect(suggestion) {
        this.company = suggestion.data;
        this.company_name = this.company.name.short_with_opf;
        this.company_inn = this.company.inn;
        this.company_kpp = this.company.kpp;
        this.company_address = this.company.address.value;
        if (this.company.address.data.qc === "0") {
            this.company_address = [
                this.company.address.data.postal_code,
                this.company_address,
            ].join(", ");
        }
    },

    onSelectNothing() {
        this.company = null;
        this.company_name = "";
        this.company_inn = "";
        this.company_kpp = "";
        this.company_address = "";
    },

    async save() {
        const data = {
            csrf_token: this.csrf_token,
            company_name: this.company_name,
            company_inn: this.company_inn,
            company_kpp: this.company_kpp,
            company_address: this.company_address,
            industry: this.industry,
            role: this.role,
        };
        await this.post(data);
    },

    async post(data) {
        const options = {
            method: "POST",
            body: new URLSearchParams(data)
                .toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json",
                "X-CSRFToken": CSRF_TOKEN,
            },
        };

        const response = await fetch("/profile/welcome/", options);
        if (response.status !== 200) {
            const result = await response.json();
            this.errors = result.errors;
            return;
        }

        this.errors = {};
        this.finish();
    },
    finish() {
        this.finished = true;
    },

    close() {
        this.$el.parentNode.removeChild(this.$el);
    },

    async getCompanyByEmail() {
        try {
            const email = window.DA.user.username;
            const api = new ApiRequest(`${BASE_URL}/findByEmail/company`, {
                csrf: CSRF_TOKEN,
                token: TOKEN,
            });
            const result = await api.send({ query: email });
            if (result.suggestions.length === 0) {
                return;
            }
            const { data } = result.suggestions[0];
            if (data.company === null) {
                return;
            }
            if (data.email.type !== "ROLE" && data.email.type !== "CORPORATE") {
                return;
            }

            this.company_name = data.company.name;
            this.company_inn = data.company.inn;
        } catch (e) {
            // игнорируем ошибку, пользователь укажет компанию вручную
        } finally {
            this.show = true;
        }
    },

    setFocus() {
        if (this.company_name) {
            this.$refs.company_industry.focus();
        } else {
            this.$refs.company_name.focus();
        }
    },
};

async function mounted() {
    await this.getCompanyByEmail();
    this.user_id = window.DA.user.id;
    this.csrf_token = window.DA.settings.CSRF_TOKEN;
    this.$nextTick(this.init);
}

const localConfig = {
    data: state,
    mounted,
    methods,
};

createComponent(localConfig, ".js-success-registration");

export default {};
